import {
  createCaseIndexMapping,
  createLabelMapping,
  getLastLabelByCaseIndex,
  updateCases,
  updatePipeConfigs,
} from './utils/caseLabelUtils';

export const resetLabels = (cases, pipeConfigs) => {
  const caseIndexMapping = createCaseIndexMapping(cases);
  const labelMappedConfig = createLabelMapping(cases, true);

  return {
    updatedCases: updateCases(cases, labelMappedConfig, caseIndexMapping),
    updatedPipeConfigs: updatePipeConfigs(pipeConfigs, labelMappedConfig, caseIndexMapping),
    lastLabels: getLastLabelByCaseIndex(caseIndexMapping, labelMappedConfig),
  };
};
